import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import Button from 'components/common/Button';

const assetFile = (device, rate, name) => {
  let rateName = rate === 1 ? '' : `@${rate}x`;
  return `./images/${device}/@${rate}x/ic_facility_${name}${rateName}.png`;
};

const FacilityHeader = ({
  className,
  name,
  title,
  count,
  opened,
  handleClickToggle
}) => (
  <h4 className={className}>
    {name !== 'other' && (
      <Image
        pc1x={assetFile('PC', 1, name)}
        pc2x={assetFile('PC', 2, name)}
        sp2x={assetFile('SP', 2, name)}
        sp3x={assetFile('SP', 3, name)}
        alt={`ic_facility_${name}`}
      />
    )}
    <span>{title}</span>
    {count > 5 && (
      <Button
        buttonType="E"
        onClick={handleClickToggle}
        className={`${opened ? 'opened' : ''}`}
      >
        {opened ? '閉じる' : 'すべて表示'}
      </Button>
    )}
  </h4>
);

const commonStyle = css`
  ${FontStyles.text14};
  position: relative;
  color: ${Colors.black1};
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 16px;

  picture {
    background-color: ${Colors.white1};
    position: relative;
    z-index: 2;
    padding-right: 20px;
  }

  span {
    display: inline-block;
    padding-right: 20px;
    background-color: ${Colors.white1};
    position: relative;
    z-index: 2;

    &:after {
      content: ' ';
      position: absolute;
      top: 50%;
      right: -56px;
      border: 0;
      width: 56px;
      border-top: solid 1px ${Colors.orange1};
      z-index: 1;
    }
  }

  &:before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0;
    border: 0;
    width: 100%;
    border-top: solid 1px ${Colors.gray2};
    z-index: 0;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  height: 52px;

  button {
    margin-left: auto;
    position: relative;
    z-index: 1;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  button {
    display: none;
  }
`;

export default applyStyles(FacilityHeader)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/FacilityHeader.js